import axios from '../axios/axios.js'
export default {
	setInfo(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/setInfo', data, (res) => {
				resolve(res)
			}, (erro) => {
				reject(erro)
			})
		})
	},
	getInfo(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/getInfo', data, (res) => {
				resolve(res)
			}, (erro) => {
				reject(erro)
			})
		})
	},	
	getHongbao(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/getHongbao', data, (res) => {
				resolve(res)
			}, (erro) => {
				reject(erro)
			})
		})
	},	
	gift(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/gift', data, (res) => {
				resolve(res)
			}, (erro) => {
				reject(erro)
			})
		})
	},
	getgift(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/getgift', data, (res) => {
				resolve(res)
			}, (erro) => {
				reject(erro)
			})
		})
	},	
		
	isGameSuccess(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/isGameSuccess', data, (res) => {
				resolve(res)
			}, (erro) => {
				reject(erro)
			})
		})
	},		
	gameSuccess(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/gameSuccess', data, (res) => {
				resolve(res)
			}, (erro) => {
				reject(erro)
			})
		})
	},			
		
	
	getma(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post('/getma', data, (res) => {
				resolve(res)
			}, (erro) => {
				reject(erro)
			})
		})
	},
	getJssdk(url) {
		return new Promise((resolve, reject) => {
			axios.post('/getJssdk', {
				url: url
			}, (res) => {
				resolve(res)
			}, (erro) => {
				reject(erro)
			})
		})
	},

}
